import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ShieldCheck, AlertTriangle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { adminLoggedIn, adminLogin } = useApp();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  if (adminLoggedIn) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(u, p);
      toast({ title: "Bun venit!", description: "Te-ai autentificat în panoul de administrare." });
      navigate("/admin");
    } catch (err) {
      toast({ title: "Date incorecte", description: err?.response?.data?.detail || "Verifică utilizatorul sau parola." });
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-10 fade-in">
      <div className="w-full max-w-md amd-card rounded-lg p-6 md:p-8">
        <div className="flex items-center gap-2 mb-1">
          <ShieldCheck className="w-5 h-5" style={{ color: "var(--amd-primary)" }} />
          <span className="text-xs uppercase tracking-wider font-bold" style={{ color: "var(--amd-primary)" }}>Acces administrare</span>
        </div>
        <h1 className="text-2xl font-black text-white">Conectează-te la amd64</h1>
        <p className="text-sm mt-1" style={{ color: "var(--amd-text-muted)" }}>Panoul de administrare al site-ului.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Utilizator</Label>
            <Input value={u} onChange={(e) => setU(e.target.value)} placeholder="admin" className="amd-input mt-1.5 h-11" autoFocus />
          </div>
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Parolă</Label>
            <Input type="password" value={p} onChange={(e) => setP(e.target.value)} placeholder="••••••••" className="amd-input mt-1.5 h-11" />
          </div>
          <Button type="submit" disabled={loading} className="amd-btn-primary w-full h-11 font-semibold">{loading ? "…" : "Autentificare"}</Button>
        </form>

        <div className="mt-5 text-xs flex items-start gap-2 p-3 rounded-md" style={{ background: "var(--amd-surface-alt)", color: "var(--amd-text-muted)" }}>
          <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "#f59e0b" }} />
          <div>Demo: utilizator <strong className="text-white">admin</strong>, parolă <strong className="text-white">amd64admin</strong>.</div>
        </div>
      </div>
    </div>
  );
}
